type QueryWithHttpResponse = {
  isError: boolean
  data?: { status: number }
}

/**
 * TanStack Query only marks transport failures as errors because the generated
 * client deliberately returns HTTP response envelopes. Treat every unexpected
 * HTTP status as a query failure at the presentation boundary.
 */
export function queryHasHttpError(
  query: QueryWithHttpResponse,
  successStatuses: readonly number[] = [200],
): boolean {
  return query.isError || (query.data !== undefined && !successStatuses.includes(query.data.status))
}
